import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import PermContactCalendarTwoToneIcon from '@mui/icons-material/PermContactCalendarTwoTone';
import DashboardCustomizeTwoToneIcon from '@mui/icons-material/DashboardCustomizeTwoTone';
import ViewCarouselTwoToneIcon from '@mui/icons-material/ViewCarouselTwoTone';
import CollectionsTwoToneIcon from '@mui/icons-material/CollectionsTwoTone';
import VideoCameraBackTwoToneIcon from '@mui/icons-material/VideoCameraBackTwoTone';
import AudioFileTwoToneIcon from '@mui/icons-material/AudioFileTwoTone';
import ViewAgendaTwoToneIcon from '@mui/icons-material/ViewAgendaTwoTone'; 
import SchoolTwoToneIcon from '@mui/icons-material/SchoolTwoTone';
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import KrishnaLogo from "../Assets/KPS_Logo.png";

export default function AdminNavabr() {

  const handleLogout = () => {
    fetch(`/Logout`, {
      method: 'POST',
    })
      .then((response) => {
        if (response.status === 200) {
          window.localStorage.removeItem("isLoggedIn");
          window.location.href = "/";
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error('Logout failed:', error);
      });
  };

  const closeNavbar = () => {
    const navbarToggler = document.querySelector('.navbar-toggler');
    if (navbarToggler) {
      navbarToggler.click();
    }
  };

  let inactivityTimeout;
  const resetInactivityTimeout = () => {
    clearTimeout(inactivityTimeout);
    inactivityTimeout = setTimeout(handleLogout, 20 * 60 * 1000);
  };

  useEffect(() => {
    resetInactivityTimeout();
    document.addEventListener('mousemove', resetInactivityTimeout);
    document.addEventListener('keydown', resetInactivityTimeout);

    return () => {
      clearTimeout(inactivityTimeout);
      document.removeEventListener('mousemove', resetInactivityTimeout);
      document.removeEventListener('keydown', resetInactivityTimeout);
    };
  });

  return (
    <>
      <nav className="navbar shadow-sm bg-white fixed-top">
        <div className="container-fluid">
          <div className="flex items-center gap-3">
            <img src={KrishnaLogo} alt="logo" className="h-10 sm:h-12 lg:h-16 w-auto" />
            <div>
              <h1 className="text-2xl font-bold text-gray-900 leading-tight">
                Krishna Public School
              </h1> 
            </div>
          </div>
          <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>
          <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
            <div className="offcanvas-header">
              <div className="flex items-center gap-2">
                <img src={KrishnaLogo} alt="logo" className="h-10 w-auto" />
                  <div>
                    <h2 className="text-sm font-bold text-gray-900">
                      Krishna
                    </h2>
                    <p className="text-xs text-gray-600">Public School</p>
                  </div>
                </div>
              <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                <li className="nav-item"><Link className="nav-link fw-bold" aria-current="page" to="/Dashboard" onClick={closeNavbar}><DashboardCustomizeTwoToneIcon className="me-2 text-indigo-600" />Dashboard</Link></li>
                <li className="nav-item"><Link className="nav-link fw-bold" to="/AddCarousel" onClick={closeNavbar}><ViewCarouselTwoToneIcon className="me-2 text-fuchsia-600" />Upload Carousel</Link></li>
                <li className="nav-item"><Link className="nav-link fw-bold" to="/AddGallery" onClick={closeNavbar}><CollectionsTwoToneIcon className="me-2 text-lime-600" />Upload Gallery</Link></li>
                <li className="nav-item"><Link className="nav-link fw-bold" to="/AddVideo" onClick={closeNavbar}><VideoCameraBackTwoToneIcon className="me-2 text-emerald-600" />Upload Video</Link></li>
                <li className="nav-item"><Link className="nav-link fw-bold" to="/AddDocument" onClick={closeNavbar}><AudioFileTwoToneIcon className="me-2 text-cyan-600" />Upload Document</Link></li>
                <li className="nav-item"><Link className="nav-link fw-bold" to="/AddTc" onClick={closeNavbar}><PermContactCalendarTwoToneIcon className="me-2 text-violet-600" />Upload Tc</Link></li> 
                <li className="nav-item"><Link className="nav-link fw-bold" to="/ViewEnquiry" onClick={closeNavbar}><ViewAgendaTwoToneIcon className="me-2 text-yellow-600" />View Enquiry</Link></li>
                <li className="nav-item"><Link className="nav-link fw-bold" to="/ViewAdmissions" onClick={closeNavbar}><SchoolTwoToneIcon className="me-2 text-amber-600" />View Admissions</Link></li>
                <li className="nav-item"><Link className="nav-link fw-bold" to="/" onClick={handleLogout}><LogoutRoundedIcon className="me-2 text-red-600" />Log out</Link></li> 
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}
